import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';

import Nav from '../components/Navbar';
import { AppState } from '../store/config';
import {
  getSupportTicketById,
  commentOnTicket,
} from '../state/actions/support/actions';
import {
  Jumbotron,
  Container,
  Card,
  Form,
  Button,
  Spinner,
} from 'react-bootstrap';
import { decodeToken } from '../utils/checkToken';
import { CommentStyles, CardStyle } from './styles/comments';
import { AxiosResponse } from 'axios';
import { Loaders } from './styles/dashboard';

type Props = ReturnType<typeof mapStateToProps> & any;
const TicketComment: React.FC<Props> = ({
  getSupportTicketById,
  ticket,
  comment,
  loading,
  commentOnTicket,
}) => {
  const { id } = useParams();

  useEffect(() => {
    getSupportTicketById(id);
  }, [comment]);

  const [newComment, setComment] = useState('');

  const user = decodeToken();

  const submitComment = (e: React.FormEvent<HTMLInputElement>) => {
    e.preventDefault();
    commentOnTicket(id, { comment: newComment }).then((res: AxiosResponse) => {
      if (res.status === 201) {
        setComment('');
      }
    });
  };
  const disable = ticket?.ticket.comments.length === 0;
  const cannotComment = disable && !user!.isSupport;
  const resolve = ticket?.ticket.status === 'RESOLVED';
  return (
    <div>
      <Nav />
      <Container>
        {loading ? (
          <Loaders>
            <Spinner animation="border" variant="primary" />
          </Loaders>
        ) : (
          <>
            <Jumbotron>
              <Container>
                {ticket?.ticket && (
                  <>
                    <h3 style={{ fontSize: '2rem' }}>{ticket?.ticket.title}</h3>
                    <hr />
                    <span>{ticket?.ticket.message}</span> |{' '}
                    <span className="text-muted">
                      Created on:{' '}
                      {moment
                        .utc(ticket?.ticket.createdAt)
                        .format('MMMM Do, YYYY')}{' '}
                    </span>
                  </>
                )}
              </Container>
            </Jumbotron>

            <CommentStyles>
              <div className="comments">
                {cannotComment ? (
                  <div className="no-comment">
                    <p className="text-muted">
                      You can't comment on this ticket yet. Please wait for the
                      support agents to respond to it
                    </p>
                  </div>
                ) : resolve ? (
                  <div className="no-comment">
                    <p className="text-muted">
                      This ticket is resolved. No more comments allowed
                    </p>
                  </div>
                ) : (
                  ''
                )}
                {ticket?.ticket.comments.map((comment: any, idx: number) => (
                  <CardStyle
                    key={idx}
                    // @ts-ignore
                    user={user!.id === comment.created_by ? 'flex-end' : null}
                  >
                    <Card.Body>
                      <Card.Subtitle className="mb-2 text-muted">
                        {user!.id === comment.created_by
                          ? user!.username
                          : 'Support Agent'}
                      </Card.Subtitle>
                      <Card.Text>{comment.comment}</Card.Text>
                    </Card.Body>
                    <Card.Footer className="text-muted">
                      {moment.utc(comment.createdAt).fromNow()}
                    </Card.Footer>
                  </CardStyle>
                ))}
              </div>
              <Form inline onSubmit={submitComment}>
                <Form.Label htmlFor="comment" srOnly>
                  Name
                </Form.Label>
                <Form.Control
                  className="mb-2"
                  id="comment"
                  placeholder="Comment"
                  value={newComment}
                  onChange={(e) => setComment(e.target.value)}
                  disabled={cannotComment}
                />
                <Button type="submit" className="mb-2" disabled={cannotComment}>
                  Submit
                </Button>
              </Form>
            </CommentStyles>
          </>
        )}
      </Container>
    </div>
  );
};

const mapStateToProps = ({ supportReducer }: AppState) => ({
  ticket: supportReducer.ticket,
  comment: supportReducer.comment,
  loading: supportReducer.loading,
});
export default connect(mapStateToProps, {
  getSupportTicketById,
  commentOnTicket,
})(TicketComment);
